export const MAX_ACCOUNT_SOCIAL_LINK = 6;
export const MAX_ACCOUNT_CUSTOM_LINK = 20;
export const MAX_ACCOUNT_ORDER_LINK = 20;
